import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { SPACE_SERVICE } from '@eggplant/api-hosts'
import type {
  Error,
  Space
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  spaceId: string
  children?: (response: Space) => ReactElement
  onSuccess?: (data: Space) => void
  onError?: (error: Error) => void
}

const GetSpaceRequest = ({
  spaceId,
  onSuccess,
  onError,
  children
}: Props) => {
  const url = `${SPACE_SERVICE}/spaces/${spaceId}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetSpaceRequest
